export const inspectNull = () => "null"
